import axios, { AxiosResponse } from "axios";
import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Button, Checkbox, Dropdown } from "semantic-ui-react";
import { AdminContext } from "../../contexts/AdminContext";
import AuthContext from "../../contexts/AuthContext";
import { postRequest } from "../../services/axiosService";
import { IField } from "../Interfaces/AdminInterface";
import CMDropdownOptions from "../ContentManager/CMDropdownOptions";

const options = [
    {
        key: 0,
        text: 'Hourly',
        value: 0,
    },
    {
        key: 1,
        text: 'Daily',
        value: 1,
    },
    {
        key: 2,
        text: 'Weekly',
        value: 2,
    },
    {
        key: 3,
        text: 'Monthly',
        value: 3,
    }
]

function TableConfig() {

    const [tablesPerPage, setTablesPerPage] = useState<number>(10);
    const [restrictField, setRestrictField] = useState<IField>();
    const [cacheTableData, setCacheTableData] = useState<boolean>(false);
    const [cacheSchedule, setCacheSchedule] = useState<number>(0);
    const [cacheHour, setCacheHour] = useState<number>(7);
   
    const { tableSettings, setTableSettings } = useContext(AdminContext);
    const { auth } = useContext(AuthContext);


    useEffect(() => {
        getTableSettings();
    }, []);

    const getTableSettings = () => {
        setTablesPerPage(tableSettings.tablesPerPage);
        setRestrictField(tableSettings.restrictionField);
        setCacheTableData(tableSettings.cacheTableData);
        setCacheSchedule(tableSettings.cacheFrequency);
        setCacheHour(tableSettings.cacheStartHour);
    }

    const saveSettings = async () => {
        try {
            if (tablesPerPage < 1 || tablesPerPage > 500) {
                toast.error(`Tables per page cannot exceed 500`);
                return;
            }

            let newSettings = {
                tablesPerPage: tablesPerPage,     
                restrictionField: restrictField,
                cacheTableData: cacheTableData,
                cacheFrequency: cacheSchedule,
                cacheStartHour: cacheHour
            }

            let response: AxiosResponse = await postRequest(auth, `/Admin/SaveTableSettings`, newSettings); 

            toast.success(`Settings saved`);
            setTableSettings(newSettings);
        } catch (error) {
            console.log(error);
            toast.error(`Unable to save Settings`);
        }
    }

    const handleBlur = (e: any) => {
        if (e.currentTarget.value === '0') e.currentTarget.value = '1'
    }

    const  handleKeypress = (e: any) => {
        const characterCode = e.key
        if (characterCode === 'Backspace') return

        const characterNumber = Number(characterCode)
        if (characterNumber >= 0 && characterNumber <= 9) {
            if (e.currentTarget.value && e.currentTarget.value.length) {
                return
            } else if (characterNumber === 0) {
                e.preventDefault()
            }
        } else {
            e.preventDefault()
        }
    }

    return (
        <div id="table-settings" className="ui admin-container">
            <div className="header blue headerStyleBlue">Table Settings</div>

            <div className="header gray headerStyleGray" >DISPLAY TABLES PER PAGE</div>
            <div className="meta" style={{ marginLeft: '10px' }}>The amount of created tables to display on the CM2WebShare homepage</div>
            <div className="ui input fluid" style={{ width: '80%', marginLeft: '10px', marginBottom:'10px' }} >
                <input type="number" style={{ backgroundColor: "#e5e5e5" }} placeholder="Enter Amount of Tables Per Page" id="tablesPerPage" min={1} max={500} onKeyDown={handleKeypress} onBlur={handleBlur} value={tablesPerPage} onChange={(e) => {setTablesPerPage(e.target.valueAsNumber)}} />
            </div>

            <div className="header gray headerStyleGray" >RESTRICTION FIELD</div>
            <div className="meta" style={{ marginLeft: '10px' }}>Set the restriction field used for limiting searching based on the boolean additional field</div>
            <div style={{ marginLeft: 10, width: '80%' }}>
                <CMDropdownOptions name="booleanFields" endpoint="GetAllFields?type=boolean" currentValue={restrictField}
                    placeHolder="Enter Restriction Field..." callback={(e: any) => setRestrictField(e)}
            />
            </div>

            <div style={{ marginTop: 5, marginLeft: 10 }}>
                <Checkbox toggle label='Cache Table Data' onChange={() => setCacheTableData(!cacheTableData)} checked={cacheTableData} style={{ marginRight: 10 }} />

                {cacheTableData && (
                    <>
                        <div className="header gray headerStyleGray">CACHE SCHEDULE</div>
                        <div className="ui input fluid" >
                            <Dropdown fluid style={{ backgroundColor: "#e5e5e5", width: '80%' }} className='inputs' id="cacheSchedule" placeholder='Select Cache Schedule' selection options={options} onChange={(e: any, data: any) => setCacheSchedule(data.value)} value={cacheSchedule} />
                        </div>

                        {cacheSchedule !== 0 && (
                            <>
                            <div className="meta">Select the hour (in 24 hours time) that tables will be cached</div>

                            <div className="ui input fluid" style={{ width: '80%',  marginBottom: '10px' }} >
                                <input type="number" style={{ backgroundColor: "#e5e5e5" }} placeholder="Enter Cache Hour" id="cacheHour" min={0} max={24} onKeyDown={handleKeypress} onBlur={handleBlur} value={cacheHour} onChange={(e) => { setCacheHour(e.target.valueAsNumber) }} />
                                </div>
                            </>
                        )}
                        
                    </>
                )}
                
            </div>

            <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "left", alignContent: "stretch", margin: 10 }}>
                <Button id="email-save" style={{ marginTop: 20 }} onClick={saveSettings}>Save</Button>
                <Button id="email-cancel" style={{ marginTop: 20, marginLeft: 5 }} onClick={getTableSettings}>Cancel</Button>
            </div>
        </div>
    )
}

export default TableConfig;